import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-legal-dialogs',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule],
  templateUrl: './legal-dialogs.component.html',
  styleUrl: './legal-dialogs.component.scss',
})
export class LegalDialogsComponent {
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  @Input() tipo: 'aviso-legal' | 'privacidad' | 'cookies' | 'condiciones' = 'aviso-legal';

  get titulo() {
    switch (this.tipo) {
      case 'privacidad':
        return 'Política de privacidad';
      case 'cookies':
        return 'Política de cookies';
      case 'condiciones':
        return 'Condiciones de uso';
      default:
        return 'Aviso legal';
    }
  }

  cerrar() {
    this.visible = false;
    this.visibleChange.emit(false);
  }
}
